import { IFilterContent } from '../../lists/listTypes';

export interface IConnectionRequestState {
    Id: number;
    IdAgency: number;
    Agency: string;
    AgencyLogo: string;
    IdStatus: number;
    StatusKey: string;
    Status: string;
    StatusColor?: string;
    RequestDate: string;
    ResolutionDate: string;
    DateLastUpdated: string;
    RequestedBy: number;
}

export interface IFiltersState {
    IdZinantisConnectionRequestStatusType: IFilterContent;
    IdAgency: IFilterContent;
    RequestedFrom: IFilterContent;
    RequestedTo: IFilterContent;
}

export interface IFilterOptionState {
    Id: string | number;
    label: string;
    color?: string;
}

export enum ConnetionRequestSource {
    AGENCY = 0,
    OWNER = 1,
}
